import { useState, useCallback, useEffect, useRef } from 'react'
import { getEnvironment } from 'src/config/env'
import { selectMarketState, selectPostalCode } from '../reducers/market'
import { useSelector } from 'react-redux'
const env = getEnvironment()

export const useIsFuboSportsAvailable = () => {
  const postalCode = useSelector(selectPostalCode)
  const { regionCode } = useSelector(selectMarketState)
  const [isAvailable, setIsAvailable] = useState(null)
  const hasChecked = useRef(false)
  const checkAvailability = useCallback(async () => {
    if (!postalCode || !regionCode) return

    try {
      const response = await fetch(`${env.default.host}/data/fubo_sports/${regionCode}.json`)
      if (!response.ok) {
        // If file doesn't exist, treat as not available, don't throw
        setIsAvailable(false)
        return
      }
      const postalCodes = await response.json()
      if (Array.isArray(postalCodes)) {
        setIsAvailable(postalCodes.includes(postalCode))
      } else {
        setIsAvailable(false)
      }
    } catch (error) {
      console.error(`Error checking fubo sports availability:`, error)
      setIsAvailable(false)
    }
  }, [postalCode, regionCode])

  useEffect(() => {
    if (!hasChecked.current && postalCode && regionCode) {
      checkAvailability()
      hasChecked.current = true
    }
  }, [postalCode, regionCode, checkAvailability])

  return { isAvailable }
}
